import { docOutline } from "@/components/docs/headings";
import type { DocBlock } from "@/content/docs/types";

/** On-this-page navigation, built from the same ids the renderer emits. */
export function DocToc({ blocks }: { blocks: readonly DocBlock[] }) {
  const outline = docOutline(blocks).filter((entry) => entry.level === 2);
  if (outline.length < 2) return null;

  return (
    <nav aria-label="On this page">
      <p className="text-xs font-semibold tracking-wide text-muted-foreground">On this page</p>
      <ul className="mt-3 space-y-2 border-l border-border text-sm">
        {outline.map((entry) => (
          <li key={entry.id}>
            <a
              href={`#${entry.id}`}
              className="-ml-px block border-l border-transparent pl-3 leading-snug text-muted-foreground transition-colors hover:border-primary hover:text-foreground"
            >
              {entry.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
